import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the page to top whenever the route changes.
 * Used in App.js inside <BrowserRouter> to guarantee every navigation
 * opens at the top — including hash-less route changes.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // `auto` (instant) — feels more reliable than smooth for route changes
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
}
